import axios from 'axios'

export const Form = {
    Contact: {
        post: data => axios.post('/forms/contact/', { ...data }),
    },
    GeneralApplication: {
        post: data => axios.post('/forms/general-application/', { ...data }),
    },
}